import { mergeOverrides } from 'baseui'
import type { DatepickerOverrides } from 'baseui/datepicker'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { pulseDatePickerOverrides } from './styled-components'

const useSDDatePicker = (overrides?: DatepickerOverrides) => {
  const isPulse = usePulseScope()

  return { datePickerOverrides: isPulse ? mergeOverrides(pulseDatePickerOverrides, overrides ?? {}) : overrides }
}

export default useSDDatePicker
